<template>
    <div class="app-container">
        <div class="logo">
            <img class="image" src="../../assets/activityUrl/rysBanner.png" alt="" />
            <div class="userForm">
                <!-- 用户信息 -->
                <van-form @submit="onSubmit" label-width="20vw" style="box-sizing:border-box" label-align="right"
                    validate-trigger="onSubmit">
                    <van-field v-model="userForm.phoneNumber" maxlength="11" type="tel" name="手机号" placeholder="请输入手机号"
                        capture="camera" :rules="[{ required: true, message: '' }]"
                        style="padding-left: 20px;margin-top: 10px;" />

                    <van-field v-model="userForm.smsCode" maxlength="6" name="验证码" placeholder="请输入验证码"
                        style="padding-left: 20px;" :rules="[{ required: true, message: '' }]">
                        <template #button>
                            <div round v-if="isFalg" size="small" type="info" style="color: #CE292F;" native-type="button"
                                @click="getSmsCode">
                                获取验证码
                            </div>
                            <div round v-else disabled size="small" style="color: #CE292F;" type="info">
                                {{ time }}秒后获取
                            </div>
                        </template>
                    </van-field>
                    <van-field v-model="userForm.upReferKey" maxlength="18"
                        name="邀请码" style="padding-left: 20px;" placeholder="邀请码：C000010020" @focus="referKeyChange">
                    </van-field>
                    <div class="goBtn">
                        <van-button round block type="info" class="btn" native-type="submit" :disabled="btnShow">立 即 办
                            卡</van-button>
                    </div>
                    <div class="agreement">
                        <van-checkbox v-model="agreement" shape="square" class="ty" checked-color="#ee0a24" icon-size="18px"
                            style="margin: 0 10px 0 10px">
                        </van-checkbox>
                        <span class="tick">已阅读并同意<span @click="goAgreement" style="color: #2778FF;">《用户协议》</span></span>
                    </div>
                </van-form>
            </div>
        </div>

        <!-- 弹窗 -->
        <van-dialog v-model="show" :title="title" width="380">
            <div class="diaAgreement" v-html="html"></div>
        </van-dialog>
    </div>
</template>
<script>
import {
    Toast
} from "vant";
import {
    getCode,
    getOpenidBycode,
    getrongYiShenRegister,
    getRegisteredAgreement
} from "@/api/index";
export default {
    data() {
        return {
            userForm: {
                phoneNumber: "", //  手机号
                smsCode: "", //  验证码
                upReferKey: null, //  邀请码
                openId: null,
            },
            isInitialize: false, //是否初始化
            isFalg: true, //  获取验证码按钮是否禁用
            time: null, //  倒计时
            zIndex: -1,
            agreement: false, //  协议
            goUrl: "", //  去申请的 链接地址
            btnShow: false, // 控制按钮的开饭
            code: "", //  资源 编 码
            referKey: "", //  合伙人邀请码
            browser: false,
            openId: null,
            show: false, // 弹窗的关闭隐藏
            title: "", //  对话框的标题
            html: "",
        }
    },
    created() {
        this.getisweixing();
        this.getagreement();
        this.getAuthCode()
        // this.getOpenId() //调试模式
    },
    mounted() {

    },
    methods: {
        // 用户协议获取
        getagreement() {
            getRegisteredAgreement({ articleTypes: [15] }).then(res => {
                let arr = []
                arr = res.data.find(item => item.id == 82)
                if (!arr) return this.introduce = res.data[0].content.replace(/\<img/gi, '<img style="width:188%"')
                this.html = arr.content.replace(/\<img/gi, '<img style="width:188%"')
            })
        },
        getAuthCode() {
            let appid = "wx1935b7d44e9fbee2"; //开发者appid
            let redirect = encodeURIComponent(window.location.href); //重定向回来的地址
            let wx_code = this.getUrlParam("code"); // 截取url中的code
            //判断有没有code
            if (!wx_code) {
                console.log('进入授权', redirect)
                //获取code的地址。获取成功重定向后地址栏中将会带有code，判断没有code的话，就跳转到微信官方链接上获取，获取成功后会再重定向回来，注意url是需要使用encodeURIComponent处理一下编码的
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
            } else {
                console.log('传递code', wx_code)
                // 获取到了code
                this.getOpenId(wx_code); //把code传给后台获取用户信息
            }
        },
        //getUrlParam方法就是使用正则截取地址栏里的code
        getUrlParam: function (name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        },
        getOpenId(code) {
            //这里调用后端给的接口吧code传过去就好了
            getOpenidBycode(code).then(res => {
                this.userForm.openId = res.data.openid
                if (res.data.auth) {
                    this.$store.commit('saveToken', res.data.auth.token)
                    this.$router.push({ path: '/creditCard' });
                }
            })
        },
        // 输入框获取焦点
        referKeyChange() {
            if (!this.isInitialize) {
                this.$set(this.userForm, 'upReferKey', 'C000010020')
            }
            this.isInitialize = true
        },
        // 立即办卡
        async onSubmit(val) {
            this.btnShow = true;
            if (!this.agreement) {
                Toast("请阅读并勾选协议");
                this.$notify({
                    type: "warning",
                    message: "请阅读并勾选协议",
                });
                this.btnShow = false;
                return;
            }
            if (!this.userForm.upReferKey) {
                this.userForm.upReferKey = 'C000010020'
            }
            console.log(this.userForm)
            //  发起请求 获取跳转连接  请求参数看接口文档
            getrongYiShenRegister(this.userForm).then((res) => {
                if (res.code != 200) {
                    this.$notify({
                        type: "danger",
                        message: res.msg,
                    });
                    this.btnShow = false;
                    return;
                }
                this.$store.commit('saveToken', res.data.token)
                this.$router.push("/creditCard");
                this.$notify({
                    type: "success",
                    message: "信息核验成功",
                });
            });
        },
        // 获取验证码
        getSmsCode() {
            this.time = 60;
            let timer = null;
            // 验证手机号
            let str = /^[1]([3-9])[0-9]{9}$/;
            if (!str.test(this.userForm.phoneNumber)) {
                this.$notify({
                    type: "danger",
                    message: "请输入正确的手机号",
                });
                return;
            }

            this.isFalg = false;
            timer = setInterval(() => {
                this.time--;
                if (this.time <= 1) {
                    clearTimeout(timer);
                    this.isFalg = true;
                    return;
                }
            }, 1000);

            getCode(this.userForm.phoneNumber)
                .then((res) => {
                    if (res.code != 200) {
                        this.$notify({
                            type: "danger",
                            message: res.msg,
                        });
                        return;
                    }
                    this.$notify({
                        type: "primary",
                        message: "验证码已发送",
                    });
                })
                .catch((err) => {
                    console.log("err, err", err);
                    this.time = 60;
                    this.isFalg = true;
                    clearTimeout(timer);
                    // vconsole.log()
                    this.$notify({
                        type: "danger",
                        message: err.msg,
                    });
                });
        },
        // 授权协议
        goAgreement() {
            this.title = "用户协议"
            this.show = true
        },
        // 判断是否在 微信浏览器
        getisweixing() {
            var wx = window.navigator.userAgent.toLowerCase();
            if (wx.match(/MicroMessenger/i) == 'micromessenger') {
                // console.log('是微信浏览器默认走微信')
                this.browser = true;
                return true; // 是微信端
            } else {
                // console.log('不是微信浏览器绘制原生。');
                this.browser = false;
                return false;
            }
        },
    }
}
</script>
<style scoped>
.logo {
    width: 100%;
    position: relative;
}

.logo .image {
    width: 100%;
    height: 375px;
}

.app-container {

    background-color: rgb(255, 236, 223);
    height: 100vh;
    overflow: auto;
}

.userForm {
    position: absolute;
    width: 90vw;
    bottom: -260px;
    left: 8px;
    background-color: #fff;
    margin: 0 10px 20px;
    border-radius: 6px;
}

.agreement {
    width: 100%;
    padding-left: 2vw;
    margin: 20px 10px 20px;
    font-size: 13px;
    display: flex;
}

.tick span {
    color: #fa4f5f;
}

.goBtn {
    margin: 0 auto;
    width: 80vw;
    margin-top: 10px;
}

.btn {
    background: linear-gradient(180deg, #E32831 0%, #FE912F 100%);
    box-shadow: 0px 4px 5px 0px rgba(203, 10, 10, 0.2);
    border-radius: 32px;
    border: 2px solid #FFF1C5
}

::v-deep .van-dialog__header {
    padding-top: 44px;
}

.diaAgreement {
    height: 500px;
    padding: 10px;
    overflow: auto;
    text-indent: 1.5em;
}
</style>